// OAuth do Instagram (Instagram API with Instagram Login) — onboarding de contas pelo painel.
//
// O front NÃO monta mais a URL de autorização: ela vem PRONTA do backend
// (GET /server/admin/accounts/ig/oauth-url), construída a partir do env do servidor
// (client_id + redirect_uri + scopes). Assim o redirect_uri bate EXATAMENTE com o usado
// na troca code->token no callback e com o cadastro no app Meta.
//
// O front apenas ABRE a tela de autorização; o backend trata o redirect em
// /server/ig/oauth/callback (troca o code por token e salva a conta — suporta VÁRIAS contas).

import { URLS } from '../../env/urls';
import { sendServerRequest } from '../../server/request';

// Busca no backend a URL de autorização do Instagram (parâmetros vêm do env do servidor).
export async function fetchInstagramAuthorizeUrl(): Promise<string> {
  const result = await sendServerRequest('GET', URLS.admin.accounts.ig.oauthUrl);
  const url = result.data?.data?.url;
  if (!url) throw new Error('URL de autorização do Instagram não retornada pelo servidor');
  return url;
}

// Abre o fluxo de autorização numa nova aba (mantém o painel aberto). A aba é aberta no gesto
// do usuário (evita bloqueio de popup) e navegada assim que o backend devolve a URL.
export async function connectInstagramOAuth(): Promise<void> {
  const win = window.open('about:blank', '_blank');
  try {
    const url = await fetchInstagramAuthorizeUrl();
    if (win) win.location.href = url;
    else window.location.href = url; // popup bloqueado: navega na própria aba
  } catch (e) {
    win?.close();
    throw e;
  }
}
